(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-highlight"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.feature-highlights').forEach(function (section) {
    var list = section.querySelector('.feature-highlights__list');
    var dots = section.querySelectorAll('.feature-highlights__dots span');
    if (!list || !dots.length) return;

    var items = list.querySelectorAll('.feature-highlights__item');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio < 0.6) return;
          var index = Array.prototype.indexOf.call(items, entry.target);
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
        });
      },
      { root: list, threshold: 0.6 }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-strip"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.feature-strip').forEach(function (strip) {
    var list = strip.querySelector('.feature-strip__list');
    var dots = strip.querySelectorAll('.feature-strip__dots span');
    if (!list || !dots.length) return;

    var items = list.querySelectorAll('.feature-strip__item');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio < 0.6) return;
          var index = Array.prototype.indexOf.call(items, entry.target);
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
        });
      },
      { root: list, threshold: 0.6 }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hows-it-work"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.how-it-works').forEach(function (section) {
    var list = section.querySelector('.how-it-works__list');
    var dots = section.querySelectorAll('.how-it-works__dots span');
    if (!list || !dots.length) return;

    var items = list.querySelectorAll('.how-it-works__step');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio < 0.6) return;
          var index = Array.prototype.indexOf.call(items, entry.target);
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
        });
      },
      { root: list, threshold: 0.6 }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product').forEach(function (root) {
    var thumbs = root.querySelectorAll('.product__thumb');
    var slides = root.querySelectorAll('.product__slide');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-media-index');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        slides.forEach(function (s) {
          var isMatch = s.getAttribute('data-media-index') === index;
          s.classList.toggle('is-active', isMatch);
          if (!isMatch) {
            var video = s.querySelector('video');
            if (video) video.pause();
          }
        });
      });
    });

    var form = root.querySelector('[data-product-form]');
    if (!form) return;

    var variantsScript = form.querySelector('[data-product-variants]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var variantInput = form.querySelector('[data-variant-id]');
    var priceEl = form.closest('.product__info').querySelector('[data-price]');
    var addToCartBtn = form.querySelector('[data-add-to-cart]');
    var addToCartText = form.querySelector('[data-add-to-cart-text]');

    var optionButtons = form.querySelectorAll('[data-option-value]');
    var selected = {};

    optionButtons.forEach(function (btn) {
      if (btn.classList.contains('is-selected')) {
        selected[btn.getAttribute('data-option-position')] = btn.getAttribute('data-value');
      }
    });

    function findVariant() {
      return variants.find(function (variant) {
        return Object.keys(selected).every(function (position) {
          return variant.options[parseInt(position, 10) - 1] === selected[position];
        });
      });
    }

    function updateUI() {
      var match = findVariant();
      if (!match) return;

      variantInput.value = match.id;

      if (priceEl) priceEl.textContent = match.price;

      if (addToCartBtn) {
        addToCartBtn.disabled = !match.available;
        if (addToCartText) {
          addToCartText.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
      }
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var position = btn.getAttribute('data-option-position');
        var group = form.querySelectorAll('[data-option-position="' + position + '"]');
        group.forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        selected[position] = btn.getAttribute('data-value');
        updateUI();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
